import React from 'react';
import { MobileNavigation } from './MobileNavigation';
import { 
  LayoutDashboard, 
  Router, 
  Users, 
  CreditCard, 
  Headphones, 
  Ticket,
  UserCog
} from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';

interface NavigationProps {
  currentPage: string;
  onPageChange: (page: string) => void;
}

const baseNavigationItems = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'routers', label: 'Routers', icon: Router },
  { id: 'customers', label: 'Users', icon: Users },
  { id: 'service-plans', label: 'Service Plans', icon: CreditCard },
  { id: 'vouchers', label: 'Vouchers', icon: Ticket },
  { id: 'support-tickets', label: 'Support', icon: Headphones },
];

const adminOnlyItems = [
  { id: 'accounts', label: 'Accounts', icon: UserCog },
];

export const Navigation = React.memo(function Navigation({ currentPage, onPageChange }: NavigationProps) {
  const { user } = useAuth();
  
  const navigationItems = user?.role === 'admin' 
    ? [...baseNavigationItems, ...adminOnlyItems]
    : baseNavigationItems;
  return (
    <>
      {/* Mobile Navigation */}
      <div className="md:hidden mb-6">
        <MobileNavigation currentPage={currentPage} onPageChange={onPageChange} />
      </div>
      
      {/* Desktop Navigation */}
      <nav className="hidden md:block mb-6">
        <div className="flex flex-wrap gap-1">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            return (
              <Button
                key={item.id}
                variant={currentPage === item.id ? 'default' : 'outline'}
                size="default"
                onClick={() => onPageChange(item.id)}
                className={`flex items-center space-x-2 transition-all duration-200 text-base ${
                  currentPage === item.id 
                    ? '' 
                    : 'hover:border-[var(--sw-brand)] hover:text-[var(--sw-brand)]'
                }`}
                style={currentPage === item.id ? {
                  backgroundColor: 'var(--sw-brand)',
                  borderColor: 'var(--sw-brand)',
                  color: 'white'
                } : {}}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{item.label}</span>
              </Button>
            );
          })}
        </div>
      </nav>
    </>
  );
});